import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'workflow-exit-modal',
	template: require('./workflow-exit-modal.html'),
	styles: [require('./workflow-exit-modal.scss')]
})
export class WorkflowExitModalComponent {
	@Input() nextPage: string;
	@Output() changePage: EventEmitter<boolean> = new EventEmitter();

	constructor(private activeModal: NgbActiveModal) {}

	exitWithSaving(isSaving) {
		this.changePage.emit(isSaving);
	}

	dismiss() {
		this.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/workflow-exit-modal/workflow-exit-modal.ts